<template>
    <div class="lp-wave-content">
      <div class="lp-wave-login ly-row ly-center-center">
        <div class="ly-col ly-center-center forgot-password-container" v-load-fade-in="{ delay: 1000, timeBetween: 500 }">
          <transition name="fade">
            <div v-show="true" class="card lp-load-fadein">
              <MfaSmsConfirmForm />
            </div>
          </transition>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import MfaSmsConfirmForm from './components/MfaSmsConfirmForm.vue'
</script>

<style scoped>
  .forgot-password-container {
  background: transparent !important;
  padding-bottom: 120px !important;
}

.forgot-password-container .card {
  width: 550px;
  box-shadow: none !important;
  background: transparent !important;
}
</style>
